import { connect } from 'react-redux';

import ApprovalButton from 'src/components/approval-button';
import {
  getHasCurrentUserApprovedPr,
  getIsCurrentPullRequestAuthor,
} from 'src/redux/pull-request/selectors';
import { getCurrentPullRequestActivityApprovalEvent } from 'src/redux/pull-request/selectors/activity-selectors';
import { BucketState } from 'src/types/state';

const mapStateToProps = (state: BucketState) => {
  const isPrAuthor = getIsCurrentPullRequestAuthor(state);
  const hasApproved = getHasCurrentUserApprovedPr(state);
  const approvedActivityEvent =
    getCurrentPullRequestActivityApprovalEvent(state);

  return {
    hasApproved,
    isPrAuthor,
    approvedEventDate: approvedActivityEvent?.date,
  };
};

export default connect(mapStateToProps)(ApprovalButton);
